import { render, staticRenderFns } from "./guangzhou_new.vue?vue&type=template&id=50af417f&scoped=true"
import script from "./guangzhou_new.vue?vue&type=script&lang=js"
export * from "./guangzhou_new.vue?vue&type=script&lang=js"
import style0 from "./guangzhou_new.vue?vue&type=style&index=0&id=50af417f&prod&lang=less&scoped=true"
import style1 from "./guangzhou_new.vue?vue&type=style&index=1&id=50af417f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af417f",
  null
  
)

export default component.exports